import { Logger } from "@liberty-fund/logger";
import { analytics } from "@/analytics";
import { navigationConfig } from "@/utils/navigation";
import { useDeviceDetection } from "@liberty-fund/utils/useDeviceDetection";
import { Link, useLocation } from "react-router-dom";

interface NavigationSectionProps {
  appName: string;
}

const NavigationSection = (props: NavigationSectionProps) => {
  const location = useLocation();
  const isActive = (pathname: string) => location.pathname.startsWith(pathname);
  const isMobileOrTablet = ["Mobile", "Tablet"].includes(useDeviceDetection());

  Logger.debug("APP NAV ITEMS FOR: ", { appName: props.appName });
  const navItems = navigationConfig[props.appName] ?? [];

  return (
    <>
      {navItems.map(
        (item, index) =>
          (isMobileOrTablet ? item.isMobileCompatible : true) && (
            <li key={`${props.appName}-${item.title}-${index}`}>
              <Link
                to={item.path}
                onClick={() =>
                  analytics.track("Navigation Clicked", {
                    item: item.title,
                    destination: item.path,
                    location: "sidebar",
                  })
                }
                className={`group flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-white text-opacity-80
               ${
                 isActive(item.path)
                   ? "bg-lf-blue-dark text-white text-opacity-100"
                   : "text-indigo-200 hover:bg-lf-blue-dark hover:bg-opacity-50 hover:text-white"
               }`}
                data-testid={`host-nav-${item.title.toLowerCase().replace(/ /g, "-")}-link`}
              >
                <img
                  src={item.icon.src}
                  alt=""
                  aria-hidden="true"
                  className={`h-6 w-6 shrink-0 img-white`}
                />
                {item.title}
              </Link>
            </li>
          ),
      )}
    </>
  );
};

export default NavigationSection;
